module.exports = __webpack_public_path__ + "static/media/features-invoices.f1d4e3b3.png";